export default "__VITE_ASSET__754605e2__"